import { GroupSettingsData } from "@/app/admin/groups/[id]/page";
import axios, { AxiosInstance } from "axios";

export interface learnerData {
  id: string;
  date: Date;
  progress: number;
}

export interface LearnerProgress {
  id: string;
  name: string;
  image: string;
  dataSet: learnerData[];
}

export interface GroupInfo {
  id: string;
  learnersProgress: LearnerProgress[];
  unit_session_flow_id: string;
  challenge_reflection_flow_id: string;
}

export const getAllGroups = async (axiosClient: AxiosInstance) => {
  const response = await axiosClient.get("/group");
  return response.data;
};

export const createGroup = async (axiosClient: AxiosInstance, data: any) => {
  try {
    const response = await axiosClient.post("/group", data);
    return response;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
};

export const updateGroup = async (axiosClient: AxiosInstance, data: any) => {
  try {
    const response = await axiosClient.patch(`/group/${data.id}`, {
      name: data.name,
    });
    return response;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
};

export const updateGroupPreferences = async (
  axiosClient: AxiosInstance,
  groupId: string,
  data: GroupSettingsData,
) => {
  try {
    const response = await axiosClient.patch(`/group/${groupId}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
};

export const deleteGroup = async (axiosClient: AxiosInstance, id: string) => {
  try {
    const response = await axiosClient.delete(`/group/${id}`);
    return response;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
};

export const getGroupReportInfo = async (
  axiosClient: AxiosInstance,
  id: string,
) => {
  try {
    const response = await axiosClient.get(`/group/${id}`);

    return response;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
};

export const getUserGroup = async (axiosClient: AxiosInstance) => {
  try {
    const response = await axiosClient.get("/group/user_group");
    return response;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
};

export const getGroupCourseTemplate = async (
  axiosClient: AxiosInstance,
  groupId: string,
) => {
  try {
    const response = await axiosClient.get(`/group-course/${groupId}`);
    return response;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
};

export const getGroupLogo = async (
  axiosClient: AxiosInstance,
  group: { groupId: string; invitationCode: string },
) => {
  const result = group.invitationCode
    ? await axiosClient.get(
        `group/logo-and-name/by-invitation-code/${group.invitationCode}`,
      )
    : await axiosClient.get(`group/logo/by-id/${group.groupId}`);
  return result.data;
};

export const deleteGroupCourseTemplate = async (
  axiosClient: AxiosInstance,
  courseId: string,
) => {
  try {
    const response = await axiosClient.delete(
      `/group-course/delete/${courseId}`,
    );
    return response;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
};

export const generateTemplateCertificate = async (
  axiosClient: AxiosInstance,
  templateId: string,
) => {
  try {
    const response = await axiosClient.post(
      `/user/certificate/group/generate/${templateId}`,
    );
    return response.data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
};

export const getGroupAvailableLearningLanguages = async (
  axiosClient: AxiosInstance,
  groupId: string,
) => {
  const response = await axiosClient.get(
    `/group-course/group-available-learning-languages/${groupId}`,
  );
  return response.data;
};
